import { TypographyProps } from "@commonlibs";
import { FullNumber } from "common/models";
import { FiatCurrency } from "common/models/currencies/currencies.types";

export type AppCurrency = FiatCurrency;

export enum BalanceActions {
    DISPLAY = "display",
    ADD = "add",
    SUBTRACT = "subtract",
    ROUND = "round",
    LESS = "less",
}

export type BalanceAction = `${BalanceActions}`;

export interface BalanceThreshold {
    /**
     * The maximum value that will be displayed with the specified decimals.
     */
    value: number;
    /**
     * The number of the decimals for this threshold.
     */
    decimals: number;
}

export interface BalanceProps extends Omit<TypographyProps, "children"> {
    balance: FullNumber;
    units?: AppCurrency | string;
    unitsPosition?: "left" | "right";
    action?: BalanceAction;
    options?: Intl.NumberFormatOptions;
    isLoading?: boolean;
    thresholds?: UseFormatBalanceParams["thresholds"];
    minimumFallbackDisplay?: UseFormatBalanceParams["minimumFallbackDisplay"];
}

export interface FormatBalanceOptions {
    units?: BalanceProps["units"];
    unitsPosition?: BalanceProps["unitsPosition"];
    action?: BalanceAction;
}

export interface UseFormatBalanceParams extends FormatBalanceOptions {
    thresholds?: BalanceThreshold[];
    numberFormatOptions?: Omit<Intl.NumberFormatOptions, "useGrouping">;
    /**
     * It can be a string or a function that returns a string.
     * If is a string it will be used as the minimum fallback display. Ej: "0.000001"
     * If is a function it will be called with the balance as a parameter and it should return a string. Ej: (balance) => "1 Sat"
     */
    minimumFallbackDisplay?: string | ((balance: number | string | bigint) => string);
}

export type BalanceRootProps = Pick<BalanceProps, "variant">;
